export default __webpack_public_path__ + "static/media/jiezhifa_1.6c7b8da3.png";